var map = {
	"./amor-1.png": 2078,
	"./amor-2.png": 3121,
	"./amor-3.png": 3689,
	"./ancient_wyvern_dead.png": 4111,
	"./coin.png": 3881,
	"./crown.png": 9852,
	"./cursor.png": 7398,
	"./default-amor.png": 6755,
	"./default-item.png": 4137,
	"./default-shield.png": 7096,
	"./default-weapon.png": 2177,
	"./fire_wyvern_dead.png": 1204,
	"./golem-canyon.png": 5387,
	"./golem_dead.png": 3490,
	"./ice_wyvern_dead.png": 2642,
	"./leader_golem_dead.png": 7162,
	"./necklace.png": 422,
	"./player-dead.png": 9636,
	"./player-fight.png": 7946,
	"./player.png": 182,
	"./ring.png": 124,
	"./senior_golem_dead.png": 5305,
	"./shield-1.png": 943,
	"./shield-2.png": 8197,
	"./shield-3.png": 1459,
	"./slime-field.png": 1117,
	"./undead_golem_dead.png": 9284,
	"./weapon-1.png": 1845,
	"./weapon-2.png": 7190,
	"./weapon-3.png": 7596,
	"./wyvern-cave.png": 6660,
	"./wyvern_dead.png": 7564,
	"./빨간_슬라임_dead.png": 2916,
	"./슬라임_dead.png": 401,
	"./킹_슬라임_dead.png": 2502,
	"./파란_슬라임_dead.png": 5780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7517;